import { Web3DViewer } from '@technology/web3d';
import { CapabilityProviderBase } from '@trimble/web3d-providers';
import { enableTools, NavigationTool } from '../../helpers/web3d-tool-helper';
import { CapabilityBase } from './capability-base';
import { CapabilityCategory } from './models/capability-category';

/**
 * Capability for a single viewer which is used for changing how the user navigates.
 * Setting the Web3D tools via abstract `requiredWeb3DTools` needed for navigation is required.
 */
export abstract class NavigationalCapabilityBase extends CapabilityBase {
  public override category: CapabilityCategory = CapabilityCategory.Navigation;

  protected abstract requiredWeb3DTools: NavigationTool[] | null;

  constructor(
    protected viewer: Web3DViewer,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    provider?: CapabilityProviderBase<any>
  ) {
    super(provider);
  }

  public override activate(): boolean {
    const wasSetActive = super.activate();
    if (wasSetActive) {
      this.enableRequiredTools();
    }
    return wasSetActive;
  }

  private enableRequiredTools(): void {
    enableTools(this.viewer, this.requiredWeb3DTools);
  }
}
